import React, { useEffect, useRef, useState } from "react";
import { Analytics } from "src/types/contact";
import { Bar, BarChart, Tooltip } from "recharts";
import styles from "./inlineChart.module.scss"
import CustomTooltip from "../tooltip";
import _ from "lodash";

interface IInlinePageAnalytics {
  analytics: Analytics;
  preview?: any; //TODO: Add type
}

const InlinePageAnalytics: React.FC<IInlinePageAnalytics> = ({
  analytics,
  preview,
}) => {
  const [pages, setPages] = useState<any>([]);
  const barChartRef = useRef<any>(null);
  
  const [chart, setChart] = useState({
    width: 200,
    visible: false,
  });
  useEffect(() => {
    setPages(calculatePageAnalytics());
  }, []);
  
  const totalPages = analytics.pageCount;
  let width = totalPages * 13;
  if (width > chart.width) {
    width = chart.width;
  }
  const calculatePageAnalytics = () => {
    if(!analytics || analytics.pageCount == 0 || analytics.dataPoints.length == 0){
      return [];
    }

    const pagesArr: { index: number; totalTimeSpent: number }[] = []
    for (let i = 1; i <= analytics.pageCount; i++) {
      const page = {
        index: i,
        totalTimeSpent: 0.0,
      }

      pagesArr.push(page);
    }

    analytics.dataPoints.map((element) => {
      pagesArr[element.index - 1] = element;
    })

    return pagesArr;
  };

    const renderTooltip = (props: any) => {
    const { payload } = props;

    if (payload) {
      const index = _.get(payload, "[0].payload.index", 0);
      let data = pages[index - 1] || 0;
      if(barChartRef.current){
        data = barChartRef.current.props.data[index - 1];
      }

      return (
        <CustomTooltip
          iconDimensions={{ width: 180, height: 85 }}
          timeSpentLabel=""
          activePage={data}
          preview={preview}
          className={styles.tooltip}
        />
      );
    }
    return null;
  };
  const renderPageAnalytics = () => {
    return (
            <BarChart className={styles.chart} width={width} height={45} data={pages}>
              <Bar
                ref={(element: any) => {
                    barChartRef.current = element;
                  }}
                dataKey='totalTimeSpent'
                xAxisId='index'
                yAxisId='totalTimeSpent'
                fill={"#dbdbdb"}
                barSize={20}
                minPointSize={6}
                shape={(props: any) => {
                  return (
                    <g fill="none">
                      <rect
                        x={props.x}
                        y={props.y}
                        width={props.width}
                        height={props.height}
                        fill={props.fill}
                      />
                    </g>
                  );
                }}
              >
              </Bar>
              {_.size(analytics.dataPoints) > 0 && 
                <Tooltip 
                  cursor={{ fill: '#DBDBDB' }}
                  content={(props) =>{
                    return renderTooltip(props);
                  }}
                />
              }
            </BarChart>
    )
  }


  return (
    <div className={styles.inlineChart}>
        {renderPageAnalytics()}
    </div>
  )

};


export default InlinePageAnalytics;
